module.exports = function() {
  return new Worker(__webpack_public_path__ + "32450eced8d9500885af.worker.js");
};